// extracted by mini-css-extract-plugin
module.exports = {"redaktorvarsler":"Redaktorvarsler_redaktorvarsler__MUgoc","liste":"Redaktorvarsler_liste__QnY3s"};